import React from "react";

// Бэкенд хранит эмодзи как шорткоды (:fire:); при показе подменяем на символы.
// Копирование использует исходный текст, поэтому здесь только для отображения.
const SHORTCODES: Record<string, string> = {
  ":fire:": "🔥",
  ":exclamation:": "❗",
};

function applyShortcodes(text: string): string {
  return text.replace(/:[a-z_]+:/g, (m) => SHORTCODES[m] ?? m);
}

export function parseTelegramText(text: string): React.ReactNode {
  const normalized = applyShortcodes(text.replace(/\\n/g, "\n"));

  return normalized.split("\n").map((line, i, arr) => (
    <React.Fragment key={i}>
      {parseInline(line)}
      {i < arr.length - 1 && <br />}
    </React.Fragment>
  ));
}

function parseInline(line: string): React.ReactNode {
  const parts = line.split(/(\*[^*]+\*)/g);
  return parts.map((part, i) =>
    part.startsWith("*") && part.endsWith("*") ? (
      <strong key={i} className="text-foreground font-semibold">
        {part.slice(1, -1)}
      </strong>
    ) : (
      part
    )
  );
}

export function extractTitle(text: string): string {
  const normalized = text.replace(/\\n/g, "\n");
  const firstLine = normalized.split("\n").find((l) => l.trim()) ?? "";
  return firstLine
    .replace(/\*/g, "")
    .replace(/^[\p{Emoji}\s]+/u, "")
    .trim();
}

export function extractPreview(text: string, lines = 3): string {
  const normalized = text.replace(/\\n/g, "\n");
  return normalized
    .split("\n")
    .filter((l) => l.trim())
    .slice(1, lines + 1)
    .join(" · ");
}